import { render, staticRenderFns } from "./FacilityList.vue?vue&type=template&id=15b468a6&scoped=true"
import script from "./FacilityList.vue?vue&type=script&lang=js"
export * from "./FacilityList.vue?vue&type=script&lang=js"
import style0 from "./FacilityList.vue?vue&type=style&index=0&id=15b468a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b468a6",
  null
  
)

export default component.exports